


















import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Types
import { IBlueprintField } from "@/models/provisioning";

@Component({
  components: {
    "provision-field": () =>
      import(
        "@/components/app/admin/catalogue/products/provisioning/provisionField.vue"
      )
  }
})
export default class ContractProductFunctionFieldsModal extends Mixins(
  Context
) {
  // Props
  @Prop({ required: true })
  public fields!: IBlueprintField[];
}
